import { render } from "./Tiger.vue?vue&type=template&id=165e7ba2&ts=true"
import script from "./Tiger.vue?vue&type=script&lang=ts"
export * from "./Tiger.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__